module.exports = __webpack_public_path__ + "img/22-WP8.4ac727b.jpg";